import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { submitReview } from '../../actions/reviewActions';
import StarRating from './StarRating';
import './Reviews.css';
import Cookies from 'universal-cookie';

const ReviewForm = ({ productId }) => {
    const dispatch = useDispatch();
    const { submitting } = useSelector(state => state.reviews);
    const { userInfo } = useSelector(state => state.userLogin);
    const [rating, setRating] = useState(0);
    const [comment, setComment] = useState('');

    const cookies = new Cookies();
    const isLoggedIn = !!cookies.get('tkn');

    if (!isLoggedIn) {
        return <p className='reviewLoginPrompt'>Please log in to write a review.</p>;
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!rating) { toast.warn('Please select a star rating'); return; }
        if (comment.trim().length < 5) { toast.warn('Comment must be at least 5 characters'); return; }
        dispatch(submitReview(productId, { rating, comment, userName: userInfo?.name }));
        setRating(0);
        setComment('');
    };

    return (
        <form className='reviewForm' onSubmit={handleSubmit}>
            <h4>Write a Review</h4>
            <div className='reviewFormRating'>
                <label>Your Rating</label>
                <StarRating value={rating} onChange={(_, val) => setRating(val)} />
            </div>
            <textarea
                className='reviewTextarea'
                placeholder='Share your experience (min. 5 characters)...'
                value={comment}
                onChange={e => setComment(e.target.value)}
                rows={4}
            />
            <button className='reviewSubmitBtn' type='submit' disabled={submitting}>
                {submitting ? 'Submitting...' : 'Submit Review'}
            </button>
        </form>
    );
};

export default ReviewForm;
